/** Channel contact helpers for compose and list UIs. */

export type MessagingContactChannel = 'sms' | 'email' | 'push';

export interface MemberContactFields {
  phone?: string | null;
  email?: string | null;
}

export const memberHasPhone = (row: MemberContactFields): boolean => Boolean(row.phone?.trim());

export const memberHasEmail = (row: MemberContactFields): boolean => Boolean(row.email?.trim());

/**
 * Whether a person can receive on at least one of the selected delivery channels
 * that need contact details (text or email). App notifications are ignored here.
 */
export const isReachableOnChannels = (
  row: MemberContactFields,
  channels: readonly MessagingContactChannel[],
): boolean => {
  const wantsSms = channels.includes('sms');
  const wantsEmail = channels.includes('email');
  if (!wantsSms && !wantsEmail) return true;
  return (wantsSms && memberHasPhone(row)) || (wantsEmail && memberHasEmail(row));
};

export const contactReadiness = <T extends MemberContactFields>(rows: readonly T[]) => {
  let withPhone = 0;
  let withEmail = 0;
  let missingBoth = 0;
  let missingPhone = 0;
  let missingEmail = 0;
  for (const row of rows) {
    const phone = memberHasPhone(row);
    const email = memberHasEmail(row);
    if (phone) withPhone += 1;
    else missingPhone += 1;
    if (email) withEmail += 1;
    else missingEmail += 1;
    if (!phone && !email) missingBoth += 1;
  }
  return { withPhone, withEmail, missingBoth, missingPhone, missingEmail, total: rows.length };
};
